var _style, _symbol, _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 255 255",
    style: {
      enableBackground: "new 0 0 255 255"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2B2A30;}\r\n\t.st1{fill:url(#XMLID_49_);}\r\n\t.st2{fill:url(#XMLID_50_);}\r\n\t.st3{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st4{clip-path:url(#SVGID_2_);fill:none;stroke:#FCFCFC;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st5{clip-path:url(#SVGID_2_);fill:none;stroke:#FCFCFC;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st6{clip-path:url(#SVGID_2_);}\r\n\t.st7{fill:none;stroke:#FCFCFC;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st8{clip-path:url(#SVGID_4_);fill:#FCFCFC;}\r\n\t.st9{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st10{fill:url(#XMLID_51_);}\r\n\t.st11{fill:#FFFFFF;}\r\n\t\r\n\t\t.st12{clip-path:url(#SVGID_6_);fill:none;stroke:#FCFCFC;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st13{clip-path:url(#SVGID_6_);fill:none;stroke:#FCFCFC;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st14{clip-path:url(#SVGID_6_);}\r\n\t.st15{fill:url(#XMLID_52_);}\r\n\t\r\n\t\t.st16{clip-path:url(#SVGID_8_);fill:none;stroke:#FCFCFC;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st17{clip-path:url(#SVGID_8_);fill:none;stroke:#FCFCFC;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st18{clip-path:url(#SVGID_8_);}\r\n\t.st19{opacity:0.4;fill:#FFFFFF;}\r\n\t.st20{opacity:0.6;}\r\n\t.st21{fill:#6B6B6B;}\r\n\t.st22{fill:none;stroke:#6B6B6B;stroke-miterlimit:10;}\r\n\t.st23{clip-path:url(#SVGID_11_);fill:url(#XMLID_53_);}\r\n\t.st24{clip-path:url(#SVGID_11_);}\r\n\t.st25{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st26{clip-path:url(#SVGID_11_);fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st27{clip-path:url(#SVGID_11_);fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st28{fill:#E2E1E7;}\r\n\t.st29{opacity:0.4;}\r\n\t.st30{opacity:0.21;}\r\n\t.st31{fill:#6A7EFF;}\r\n\t.st32{fill:#6D5244;}\r\n\t.st33{fill:#FE6656;}\r\n\t.st34{fill:#F49B4C;}\r\n\t.st35{fill:#F6D554;}\r\n\t.st36{fill:#3EE1E0;}\r\n\t.st37{fill:#F7C32F;}\r\n\t.st38{fill:#58E9F9;}\r\n\t.st39{fill:#606060;}\r\n\t.st40{fill:url(#SVGID_13_);}\r\n\t.st41{fill:#FFFFFF;stroke:#CCCECE;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st42{fill:none;stroke:#CCCECE;stroke-miterlimit:10;}\r\n\t.st43{fill:none;stroke:#CCCECE;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st44{fill:#2B2A30;stroke:#2B2A30;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st45{fill:#FFFFFF;stroke:#2B2A30;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st46{fill:#3D3D3D;}\r\n\t.st47{clip-path:url(#SVGID_17_);fill:#6A7EFF;}\r\n\t.st48{clip-path:url(#SVGID_21_);fill:#3EE1E0;}\r\n\t.st49{clip-path:url(#SVGID_25_);fill:#F6D554;}\r\n\t.st50{clip-path:url(#SVGID_25_);}\r\n\t.st51{clip-path:url(#SVGID_29_);fill:#F49B4C;}\r\n\t.st52{clip-path:url(#SVGID_31_);fill:#FE6656;}\r\n")), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "_x33_",
    viewBox: "-118.2 -144.5 236.4 289.1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.8-23.9c-12,2.8-24.3-2.5-35-7.6c-9.8-4.7-19-10.6-27.9-16.9C28.1-61.1,11.7-75.6-6.6-87.6 c-9.6-6.3-19.7-12.3-30.8-15.5c-11.6-3.4-23.4-2.5-34.6,2.1c-18.6,7.6-33,24.4-38.2,43.7c-2.5,9.3-2.7,19.1-0.3,28.4 c2.4,8.9,7,17.2,13.3,24c6.2,6.7,14,12,22.8,14.7c11.3,3.5,23.2,2.2,34.6-0.5c10.3-2.4,20.8-6,28.6-13.4C-7.1-8-4-12.8-1.6-17.8 c2.5-5.3,4.4-11,5.5-16.8C5.7-44.7,4-56-3.8-63.3c-8.2-7.8-20.2-6.3-29.8-2.3C-52.3-57.8-66.5-41.3-75-23.3 c-8.3,17.5-14.2,42.2-0.8,58.7C-64.7,49.1-45.5,55.7-38.8,73c4,10.4,1.4,21.6,0.4,32.2c-0.5,5.3-0.6,10.6,1.1,15.7 c1.3,4,3.7,7.4,6.9,10.2c6.4,5.5,15.3,7.8,23.7,7.2c9.7-0.7,19.1-6,26.4-12.3c8.3-7.2,15.1-16,20.7-25.3 c5.9-9.7,10.5-20.1,13.6-31.1c3-10.8,4.5-22,4.1-33.2c-0.4-12.2-3.1-24.3-6.8-35.9C47.7-11.2,42.9-22.7,37.8-34 C32.7-45.3,27.1-56.4,21-67.3C15-78.1,8.5-88.6,1.7-98.8c-6.4-9.5-13.2-18.8-21.2-27.1c-2-2.1-4.1-4.1-6.3-6 c-2-1.8-4-3.6-6.3-5.1c-0.9-0.6-1.8-1-2.7-1.3c-0.2-0.1-0.5-0.1-0.7-0.2c0,0-0.6-0.1-0.2-0.1c-0.6-0.1-0.9,0-1.1,0.1 c0.2,0-0.1,0-0.2,0.2c0.1-0.1-0.1,0.4-0.1,0.6c0,1.1,0.7,2.3,1.2,3.2c5,9.1,12.3,16.5,20.1,23.1c8,6.8,16.7,12.8,25,19.3 c9.3,7.3,17.8,15.4,26,23.9C51.2-51.3,66.6-33.3,86.6-21c9.1,5.6,18.9,9.9,29.4,11.9c1.6,0.3,2.5,2.2,2.1,3.7 c-0.5,1.7-2.1,2.4-3.7,2.1C91-7.8,71.4-22.7,54.7-39c-9.1-8.9-17.5-18.3-26.4-27.3C20-74.9,11.1-83,1.6-90.2 c-8.8-6.7-17.9-13-26-20.5c-4-3.7-7.8-7.6-11.1-11.9c-1.7-2.2-3.2-4.4-4.6-6.8c-1.5-2.5-3.2-5.3-3.1-8.4c0-2.9,1.9-5.6,4.7-6.4 c2.6-0.8,5.4,0,7.8,1.1c2.5,1.2,4.7,3.1,6.8,4.9c2.3,1.9,4.5,3.9,6.6,6c8.7,8.6,16.1,18.4,23,28.5c14.4,21.2,27,43.7,37.6,67.2 c10.6,23.4,20.5,48.2,21.1,74.2c0.5,23.9-6.9,47.7-19.6,67.8c-11.4,18.1-28.9,37.7-51.9,39c-9.7,0.6-19.7-2.5-27.1-8.8 c-3.6-3.1-6.4-7.1-8.2-11.5c-2.1-5.3-2.4-11.2-2-16.9c0.7-10.8,4.1-22.4-0.1-32.9c-3.1-7.8-10.4-13.7-17.1-18.8 c-7.5-5.8-15.4-11.4-20.8-19.3c-6.5-9.6-8-21.6-6.7-32.9c1.3-11.1,5-21.9,10-31.9c4.8-9.6,11.2-18.6,18.9-26.1 c7.8-7.6,17.2-14.1,27.5-17.7c11.2-4,24.2-3.8,33.2,4.8c8.6,8.2,11.1,20.5,9.6,31.8C9.2-29.2,7.1-23,4.5-17 C2.1-11.5-0.9-6.2-5-1.8c-7.9,8.6-19.1,13.3-30.1,16.2c-12.1,3.2-25.1,5.1-37.4,2.2c-19.8-4.7-35.9-20.8-42.5-39.8 c-6.9-20-1.9-42.6,10.5-59.3c14-18.9,37.5-31.7,61.4-27.9c12.1,1.9,23.4,7.7,33.8,14.1c9.8,6,19,12.8,28.1,19.8 c17.9,13.8,35.4,28.5,55.7,38.8c4.9,2.5,10,4.8,15.2,6.5c5.7,1.9,11.7,3.1,17.6,1.7C111-30.6,112.6-24.8,108.8-23.9L108.8-23.9z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_x5F_2_1_"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M234.4,243.9H20.6c-5.2,0-9.5-4.3-9.5-9.5V20.6c0-5.2,4.3-9.5,9.5-9.5h213.8c5.2,0,9.5,4.3,9.5,9.5v213.8 C243.9,239.6,239.6,243.9,234.4,243.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M165.3,156.4c-9.3,0-16.8-7.5-16.8-16.8c0-9.3,7.5-16.8,16.8-16.8 s16.8,7.5,16.8,16.8C182.1,148.8,174.6,156.4,165.3,156.4z M165.3,125.6c-7.7,0-14,6.3-14,14s6.3,14,14,14c7.7,0,14-6.3,14-14 S173,125.6,165.3,125.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M135.8,113.9C135.8,113.9,135.8,113.9,135.8,113.9l-60.6-8.1 c-0.4-0.1-0.7-0.4-0.6-0.8c0.1-0.4,0.4-0.7,0.8-0.6l60.5,8.1c0.4,0.1,0.7,0.4,0.6,0.8C136.5,113.7,136.2,113.9,135.8,113.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M72.9,124.9c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7l61.6-1.4 c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7L72.9,124.9C72.9,124.9,72.9,124.9,72.9,124.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M75,142.8c-0.3,0-0.6-0.2-0.7-0.6c-0.1-0.4,0.2-0.7,0.6-0.8l60.1-10.1 c0.4-0.1,0.7,0.2,0.8,0.6c0.1,0.4-0.2,0.7-0.6,0.8l-60.1,10.1C75.1,142.8,75.1,142.8,75,142.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M82.5,162c-0.3,0-0.6-0.2-0.7-0.5c-0.1-0.4,0.1-0.8,0.4-0.9l55.4-19.8 c0.4-0.1,0.8,0.1,0.9,0.4c0.1,0.4-0.1,0.8-0.4,0.9L82.7,162C82.6,162,82.5,162,82.5,162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M100.4,183.8c-0.2,0-0.4-0.1-0.5-0.3c-0.2-0.3-0.2-0.7,0.1-1l41.3-34.3 c0.3-0.2,0.7-0.2,1,0.1c0.2,0.3,0.2,0.7-0.1,1l-41.3,34.3C100.7,183.8,100.6,183.8,100.4,183.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M126.9,198.3c-0.1,0-0.2,0-0.3-0.1c-0.4-0.2-0.5-0.6-0.3-0.9l20.1-41.9 c0.2-0.4,0.6-0.5,0.9-0.3c0.4,0.2,0.5,0.6,0.3,0.9l-20.1,41.9C127.4,198.2,127.1,198.3,126.9,198.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M155.5,201.6C155.4,201.6,155.4,201.6,155.5,201.6 c-0.5-0.1-0.7-0.4-0.7-0.8l4.3-35.6c0-0.4,0.4-0.7,0.8-0.6c0.4,0,0.7,0.4,0.6,0.8l-4.3,35.6C156.1,201.4,155.8,201.6,155.5,201.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M138.6,105.9c-0.1,0-0.1,0-0.2,0L82.3,87.6c-0.4-0.1-0.6-0.5-0.5-0.9 c0.1-0.4,0.5-0.6,0.9-0.5l56.1,18.3c0.4,0.1,0.6,0.5,0.5,0.9C139.1,105.7,138.9,105.9,138.6,105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M142.5,98.9c-0.1,0-0.2,0-0.3-0.1L92.5,73.2c-0.3-0.2-0.5-0.6-0.3-1 c0.2-0.3,0.6-0.5,1-0.3l49.7,25.7c0.3,0.2,0.5,0.6,0.3,1C143,98.8,142.7,98.9,142.5,98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M147,93.3c-0.1,0-0.3,0-0.4-0.1l-41.4-31.3c-0.3-0.2-0.4-0.7-0.1-1 c0.2-0.3,0.7-0.4,1-0.1L147.4,92c0.3,0.2,0.4,0.7,0.1,1C147.4,93.2,147.2,93.3,147,93.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M152.3,88.5c-0.2,0-0.4-0.1-0.5-0.2l-31.3-35c-0.3-0.3-0.2-0.7,0.1-1 c0.3-0.3,0.7-0.2,1,0.1l31.3,35c0.3,0.3,0.2,0.7-0.1,1C152.6,88.4,152.5,88.5,152.3,88.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M176.5,129.8c-0.1,0-0.2,0-0.3-0.1c-0.3-0.2-0.5-0.6-0.3-1l10.3-19.7 c0.2-0.3,0.6-0.5,1-0.3c0.3,0.2,0.5,0.6,0.3,1l-10.3,19.7C177,129.6,176.8,129.8,176.5,129.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M179.6,134.5c-0.2,0-0.3-0.1-0.5-0.2c-0.3-0.3-0.3-0.7-0.1-1l17.2-19.2 c0.3-0.3,0.7-0.3,1-0.1c0.3,0.3,0.3,0.7,0.1,1l-17.2,19.2C180,134.4,179.8,134.5,179.6,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M180.7,140.3c-0.2,0-0.4-0.1-0.6-0.3c-0.2-0.3-0.1-0.8,0.2-1l25.2-17.7 c0.3-0.2,0.8-0.1,1,0.2c0.2,0.3,0.1,0.8-0.2,1l-25.2,17.7C181,140.2,180.8,140.3,180.7,140.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M180,144.9c-0.3,0-0.6-0.2-0.7-0.5c-0.1-0.4,0.1-0.8,0.4-0.9l31-10.4 c0.4-0.1,0.8,0.1,0.9,0.4c0.1,0.4-0.1,0.8-0.4,0.9l-31,10.4C180.1,144.9,180,144.9,180,144.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M177.3,149.8c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.6-0.8l33.4-2.7 c0.4,0,0.7,0.3,0.8,0.6c0,0.4-0.3,0.7-0.6,0.8L177.3,149.8C177.4,149.8,177.3,149.8,177.3,149.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M180.7,171.7c-17.8,0-32.2-14.4-32.2-32.2s14.4-32.2,32.2-32.2 s32.2,14.4,32.2,32.2S198.4,171.7,180.7,171.7z M180.7,110.2c-16.2,0-29.4,13.2-29.4,29.4s13.2,29.4,29.4,29.4 s29.4-13.2,29.4-29.4S196.9,110.2,180.7,110.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M180.7,171.7c-26.2,0-47.6-21.4-47.6-47.6s21.4-47.6,47.6-47.6 s47.6,21.4,47.6,47.6S206.9,171.7,180.7,171.7z M180.7,79.4c-24.7,0-44.8,20.1-44.8,44.8c0,24.7,20.1,44.8,44.8,44.8 s44.8-20.1,44.8-44.8C225.5,99.5,205.4,79.4,180.7,79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M149.9,202.5c-43.2,0-78.4-35.2-78.4-78.4s35.2-78.4,78.4-78.4 s78.4,35.2,78.4,78.4S193.1,202.5,149.9,202.5z M149.9,48.6c-41.7,0-75.6,33.9-75.6,75.6s33.9,75.6,75.6,75.6 s75.6-33.9,75.6-75.6S191.6,48.6,149.9,48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FCFCFC"
    },
    d: "M149.9,294.9c-68.7,0-124.6-55.9-124.6-124.6 c0-68.7,55.9-124.6,124.6-124.6s124.6,55.9,124.6,124.6C274.5,239,218.6,294.9,149.9,294.9z M149.9,48.6 c-67.1,0-121.7,54.6-121.7,121.7c0,67.1,54.6,121.7,121.7,121.7s121.7-54.6,121.7-121.7C271.6,103.2,217,48.6,149.9,48.6z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#FCFCFC",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_x5F_2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fisica"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_xBF_foto"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ABRAZO"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpLogo);
export default __webpack_public_path__ + "static/media/up_logo.44f3769c2b379be068ddb61f75d0e372.svg";
export { ForwardRef as ReactComponent };